/** Empresas A3 en pedidos/presupuestos (mismo orden que el back). */
export const A3_EMPRESAS_PEDIDO = [
  {
    key: "STAGE_DESIGN",
    label: "STAGE_DESIGN",
    shortLabel: "STAGE-DESIGN",
    badge: "S",
    color: "#1976d2",
    bgcolor: "rgba(25, 118, 210, 0.10)",
    chipBgcolor: "rgba(25, 118, 210, 0.45)",
    chipColor: "#000",
    border: "1px solid #1976d2",
  },
  {
    key: "ERNA_TRADE",
    label: "ERNA_TRADE",
    shortLabel: "ERNA_TRADE",
    badge: "E",
    color: "#fff",
    bgcolor: "rgba(170, 25, 196, 0.16)",
    chipBgcolor: "rgba(170, 25, 196, 0.53)",
    chipColor: "#fff",
    border: "1px solid #aa19c4",
  },
  {
    key: "NML_SPAIN",
    label: "NML_SPAIN",
    shortLabel: "NML_SPAIN",
    badge: "N",
    color: "#fff",
    bgcolor: "rgba(46, 125, 50, 0.18)",
    chipBgcolor: "rgba(46, 125, 50, 0.55)",
    chipColor: "#fff",
    border: "1px solid #2e7d32",
  },
];

const EMPRESA_BY_KEY = Object.fromEntries(
  A3_EMPRESAS_PEDIDO.map((e) => [e.key, e]),
);

export const normalizeEmpresaA3 = (raw, fallback = "STAGE_DESIGN") => {
  const v = String(raw || "")
    .trim()
    .toUpperCase();
  if (!v) return fallback;
  if (EMPRESA_BY_KEY[v]) return v;
  if (v === "ERNA") return "ERNA_TRADE";
  if (v === "NML") return "NML_SPAIN";
  if (v === "STAGE" || v === "STAGE-DESIGN") return "STAGE_DESIGN";
  return fallback;
};

export const getEmpresaA3Meta = (raw) => {
  const key = normalizeEmpresaA3(raw);
  return EMPRESA_BY_KEY[key] || EMPRESA_BY_KEY.STAGE_DESIGN;
};

export const A3_EMPRESA_DB_SOURCE_OPTIONS = A3_EMPRESAS_PEDIDO.map((e) => ({
  value: e.key,
  label: e.shortLabel,
}));
